/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmailMessagesService {

    /**
     * Gets an email message
     * @param id Email message ID
     * @param xAccessToken API Token
     * @returns any email message retrieved
     * @throws ApiError
     */
    public static getInternalApiWxEmailMessages(
        id: string,
        xAccessToken?: string,
    ): CancelablePromise<{
        body: string;
        email_type?: string | null;
        from_email: string;
        funnel_id: string;
        id: string;
        to_email: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/email_messages/{id}',
            path: {
                'id': id,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `unauthorized`,
                404: `email message not found`,
            },
        });
    }

}